import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {zIndexWindowBusy} from 'crazyEditor/core/globals';
import {MESSAGE_TYPE} from './IntegrationConsts';
import _ from 'lodash';
import {updateUserData} from 'MyAccount/ViewDesigns/redux/modules/user';

export const styles = {};

export default class IntegrationConnector extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
    store: PropTypes.object,
  };

  static childContextTypes = {
    integrationConnector: PropTypes.object,
  };

  getChildContext = () => {
    return {integrationConnector: this};
  };

  componentWillMount() {
    if (this.isIntegrationEnabled()) {
      window.addEventListener('message', this.receiveMessage, false);
      this.resizeInterval = window.setInterval(this.setIframeHeight, 50);
    }
  }

  componentDidMount() {
    if (this.isIntegrationEnabled()) {
      this.setIframeHeight();
      _.defer(() => {
        this.openIntegrationWelcomeDialog();
      });
    }
  }

  componentWillUnmount() {
    if (this.isIntegrationEnabled()) {
      window.removeEventListener('message', this.receiveMessage);
      this.sendMessage({type: MESSAGE_TYPE.ROOT_COMPONENT_WILL_UNMOUNT});
      window.clearInterval(this.resizeInterval);
    }
  }

  setIframeHeight = () => {
    const scrollHeight = window.document.body.offsetHeight;
    if (scrollHeight && this.lastScrollHeight !== scrollHeight) {
      this.lastScrollHeight = scrollHeight;
      this.sendMessage({type: MESSAGE_TYPE.SET_IFRAME_HEIGHT, scrollHeight: scrollHeight});
    }
  };

  isIntegrationEnabled() {
    return window !== window.top;
  }

  openIntegrationWelcomeDialog = () => {
    const {disableWelcomeDialog} = this.props;
    if (disableWelcomeDialog) {
      return;
    }
    const store = this.context.store;
    if (store) {
      const state = store.getState();
      const {templateTagSetName, trialEnd, thirdPartyBilling, thirdPartyLogo, templateTagSetTrialDuration} = state.user;
      if (trialEnd === null && !_.isEmpty(templateTagSetName)) {
        this.sendMessage({
          type: MESSAGE_TYPE.OPEN_INTEGRATION_WELCOME_DIALOG,
          name: templateTagSetName,
          thirdPartyBilling,
          thirdPartyLogo,
          trialDuration: templateTagSetTrialDuration,
        });
      }
    }
  };

  receiveMessage = event => {
    const message = event.data;
    switch (message.type) {
      case MESSAGE_TYPE.NAVIGATE_TO:
        const {navigationAllowed} = this.props;
        if (navigationAllowed) {
          this.context.router.push(message.url);
          window.sessionStorage.setItem('integrationCustomData', message.custom);
        }
        break;
      case MESSAGE_TYPE.START_FREE_TRIAL:
        const {startFreeTrial} = require('MyAccount/ViewDesigns/helpers/preferencesHelper');
        startFreeTrial()
          .then(response => {
            if (response.success) {
              const store = this.context.store;
              store.dispatch(updateUserData(response.user));
            } else {
              this.openIntegrationWelcomeDialog();
            }
          })
          .fail(this.openIntegrationWelcomeDialog);
        break;
      default:
        break;
    }
    if (this.isIntegrationEnabled()) {
      console.log('message received', message);
    }
  };

  sendMessage = message => {
    if (this.isIntegrationEnabled()) {
      console.log('sendingMessage', message);
      window.parent.postMessage(message, '*');
    }
  };

  render() {
    const {navigationAllowed, disableWelcomeDialog, ...other} = this.props;
    return <div {...other} />;
  }
}

IntegrationConnector.propTypes = {
  navigationAllowed: PropTypes.bool.isRequired,
  disableWelcomeDialog: PropTypes.bool,
};

IntegrationConnector.defaultProps = {
  navigationAllowed: true,
  disableWelcomeDialog: false,
};
